var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMarkAsComplete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 24,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13968",
    "data-name": "Group 13968",
    transform: "translate(7855 15378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2764",
    "data-name": "Ellipse 2764",
    transform: "translate(-7855 -15378)",
    fill: "#eaf8f2",
    stroke: "#32ba7c",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 33.5,
    cy: 33.5,
    r: 32.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tick_6_",
    "data-name": "tick (6)",
    transform: "translate(-7840.498 -15426.949)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13967",
    "data-name": "Group 13967",
    transform: "translate(0 67.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38088",
    "data-name": "Path 38088",
    d: "M37.439,68.554a1.9,1.9,0,0,0-2.687,0L11.992,91.315,3.243,82.566A1.9,1.9,0,0,0,.556,85.253L10.648,95.345a1.9,1.9,0,0,0,2.687,0l24.1-24.1A1.9,1.9,0,0,0,37.439,68.554Z",
    transform: "translate(0 -67.997)",
    fill: "#32ba7c"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkAsComplete);
export default __webpack_public_path__ + "static/media/mark-as-complete.b9809244.svg";
export { ForwardRef as ReactComponent };